import { ReferencePersonPickerDialog } from './ReferencePersonPickerDialog';
import { ElementPickerDialog } from './ElementPickerDialog';
import { SaveToProjectDialog } from './SaveToProjectDialog';
import { OptionPickerDialog } from './OptionPickerDialog';
import { PhotostudioFormColumn } from './PhotostudioFormColumn';
import { PhotostudioPreviewColumn } from './PhotostudioPreviewColumn';

import { usePhotostudioForm } from '@/hooks/usePhotostudioForm';

export function PhotostudioPageNew() {
  const form = usePhotostudioForm();

  return (
    <div className="flex gap-8 p-6">
      <PhotostudioFormColumn
        subjectAction={form.subjectAction}
        setSubjectAction={form.setSubjectAction}
        environment={form.environment}
        setEnvironment={form.setEnvironment}
        shotType={form.shotType}
        lightingSource={form.lightingSource}
        photographyGenre={form.photographyGenre}
        atmosphere={form.atmosphere}
        setAtmosphere={form.setAtmosphere}
        cameraBody={form.cameraBody}
        focalLength={form.focalLength}
        lensType={form.lensType}
        filmStock={form.filmStock}
        isGenerating={form.generation.isGenerating}
        personPreviewUrl={form.personPreviewUrl}
        outfitPreviewUrl={form.outfitPreviewUrl}
        scenePreviewUrl={form.scenePreviewUrl}
        characterSlot={form.characterSlot}
        outfitSlot={form.outfitSlot}
        sceneSlot={form.sceneSlot}
        onOpenPersonPicker={form.handleOpenPersonPicker}
        onOpenElementPicker={form.handleOpenElementPicker}
        onClearPerson={form.handleClearPerson}
        onClearOutfit={form.handleClearOutfit}
        onClearScene={form.handleClearScene}
        setVisualPickerOpen={form.setVisualPickerOpen}
      />

      <PhotostudioPreviewColumn
        constructedPrompt={form.constructedPrompt}
        resolution={form.resolution}
        setResolution={form.setResolution}
        aspectRatio={form.aspectRatio}
        setAspectRatio={form.setAspectRatio}
        isReadyToGenerate={form.isReadyToGenerate}
        isGenerating={form.generation.isGenerating}
        generatedImageUrl={form.generatedImageUrl}
        error={form.generation.error}
        onGenerate={form.handleGenerate}
        onDownload={form.handleDownload}
        onOpenSaveDialog={() => form.setSaveDialogOpen(true)}
      />

      <ReferencePersonPickerDialog
        isOpen={form.personPickerOpen}
        onClose={() => form.setPersonPickerOpen(false)}
        onSelect={form.handlePersonSelect}
      />

      <ElementPickerDialog
        isOpen={form.elementPickerOpen}
        elementType={form.elementPickerType}
        onClose={() => form.setElementPickerOpen(false)}
        onSelect={form.handleElementSelect}
      />

      <SaveToProjectDialog
        isOpen={form.saveDialogOpen}
        onClose={() => form.setSaveDialogOpen(false)}
        onSave={form.handleSaveToProject}
        selectedCount={form.generation.selectedCount > 0 ? form.generation.selectedCount : 1}
        isSaving={form.isSaving}
      />

      {form.visualPickerOpen && (
        <OptionPickerDialog
          open={form.visualPickerOpen !== null}
          onOpenChange={open => !open && form.setVisualPickerOpen(null)}
          {...form.visualPickerConfig[form.visualPickerOpen]}
        />
      )}
    </div>
  );
}
